"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

require("./Spinner.css");

var classnames_1 = __importDefault(require("classnames"));

function Spinner(_a) {
  var _b = _a.size,
      size = _b === void 0 ? "base" : _b,
      _c = _a.appearance,
      appearance = _c === void 0 ? "primary" : _c;
  var className = classnames_1.default("nimbus--spinner", "nimbus--spinner--" + appearance, "nimbus--spinner--" + size);
  var spinnerSize = {
    small: "8",
    base: "16",
    medium: "24",
    large: "32"
  };
  return React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: spinnerSize[size],
    height: spinnerSize[size],
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    className: "nimbus--spinner__left",
    d: "M8,14A6,6,0,0,1,8,2"
  }), React.createElement("path", {
    className: "nimbus--spinner__right",
    d: "M8,2A6,6,0,0,1,8,14"
  }));
}

exports.default = Spinner;